/**
*功能名称：必填
*创 建 人：弋强
*日    期：2022/09/01 14:48:10
*/
import { BaseVue } from "@newview/base-web";
import { Component, Prop, Watch } from "vue-property-decorator";
import { grid, comForm, customModal } from "@newview/ui";
@Component({
    components: {

    }
})
export default class NvListItem extends BaseVue {

    //#region 接口定义区

    //#endregion 接口定义区

    //#region 变量定义区

    listChk: boolean = false;

    //#endregion 变量定义区

    //#region 事件定义区

    mounted() {

    }

    //#endregion 事件定义区

    //#region 方法定义区

    doChange() {
        this.$emit('input', this.listChk);
    }

    //#endregion 方法定义区
}